import React from "react";
import Link from "next/link";

import {
  Attributes,
  AttributeItemBox,
  AttributeItem,
  CheckMarkIcon,
  AttributeHeading,
} from "./style";

function AttributesComponent({ data = {} }: any) {
  return (
    <Attributes>
      {data?.attributeHeading && (
        <AttributeHeading variant="label2">
          {data?.attributeHeading}
        </AttributeHeading>
      )}
      <AttributeItemBox>
        {data?.attributes.map((attribute) => (
          <h2 key={attribute.id} style={{ margin: 0 }}>
            <Link
              href={`attribute-${attribute?.slug}/`}
              prefetch={false}
              style={{ textDecoration: "none" }}
            >
              <AttributeItem variant="span">
                <CheckMarkIcon icon="icon-check-mark" />
                {attribute.title}
              </AttributeItem>
            </Link>
          </h2>
        ))}
      </AttributeItemBox>
    </Attributes>
  );
}

export default AttributesComponent;
